import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { QueryFieldGroup } from "@/app-data/patent-query";
import { isEmptyOrWhiteSpace } from "@/utils/Common";
import { API_BIS_FILTER } from "@/configs/Apis";
import { showSuccess } from "@/utils/UI";
import AdvSearch from "@/views/components/AdvSearch.vue";
import DuduAjax from "@/utils/DuduAjax";
import { useStore } from "@/stores";
import cloneDeep from "lodash/cloneDeep";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvSearchDialog',
  props: {
  condition: { type: String, required: false, default: () => "" },
},
  emits: ["query", "data-changed"],
  setup(__props, { expose, emit }) {

const props = __props;





const store = useStore();

const visible = ref(false);

const filterData = ref<any>({ name: "", markPublic: false });

const showSaveFilterWin = ref(false);

const categoryData = computed(() => (store.state as any).project.customCategoryTree);

const appendFields = computed<Array<QueryFieldGroup>>(() => {
  const fields: Array<QueryFieldGroup> = [];
  const catData = categoryData.value;
  if (!isEmptyOrWhiteSpace(catData)) {
    const treeData: Array<any> = catData;
    const categoryQueryFields = [];
    categoryQueryFields.push(
      ...treeData.map((field: any) => ({
        name: `category${field.id}`,
        label: field.name,
        type: "tree",
        treeData: cloneDeep(field.children || []),
      }))
    );
    fields.push({ name: "自定义分类", fields: categoryQueryFields });
  }
  const customFields = store.getters["project/customfields"];
  if (customFields && customFields.length) {
    const customQueryFields = [];
    customQueryFields.push(
      ...customFields.map((field: any) => {
        const item: any = { name: field.fieldName.replace("_", ""), label: field.label };
        if (field.fieldType === "ENUM") {
          item.type = "enum";
          item.enumValues = [];
          if (!isEmptyOrWhiteSpace(field.enumValues)) {
            item.enumValues.push(...field.enumValues.split(/[\r\n;]/g));
          }
        } else {
          item.type = "text";
        }
        return item;
      })
    );
    fields.push({ name: "标引字段", fields: customQueryFields });
  }
  return fields;
});

const savedFilter = ref(false);

const advRef = ref<any>(null);

const saveFormRef = ref<any>(null);

const projectId = computed(() => {
  const pInfo: any = (store.state as any).project.info || {};
  return pInfo.id || 0;
});

const dataRules = {
  name: [{ required: true, message: "请输入筛选器名称", trigger: "blur" }],
};

const open = () => {
  filterData.value = { name: "", markPublic: false };
  showSaveFilterWin.value = false;
  savedFilter.value = false;
  visible.value = true;
};

const showSaveAdvFilter = () => {
  showSaveFilterWin.value = true;
};

const saveAdvFilter = () => {
  const form = saveFormRef.value as any;
  form.validate((isValid: boolean) => {
    if (!isValid) {
      return;
    }
    const postedData = Object.assign({}, filterData.value);
    postedData.filterCondition = advRef.value.getSearchData();
    DuduAjax.post({ url: API_BIS_FILTER, path: { projectId: projectId.value } }, postedData).then(() => {
      savedFilter.value = true;
      showSuccess("保存成功");
      closeSaveDialog();
      store.dispatch("project/getCustomFilterData");
    });
  });
};

const searchData = () => {
  const queryStr = advRef.value.getSearchData();
  if (!isEmptyOrWhiteSpace(queryStr)) {
    emit("query", queryStr);
  }
  closeDialog();
};

const closeDialog = () => {
  visible.value = false;
  if (savedFilter.value) {
    emit("data-changed");
  }
};

const closeSaveDialog = () => {
  showSaveFilterWin.value = false;
  filterData.value = { name: "", markPublic: false };
};

expose({ open });

return { __sfc: true,props, emit, store, visible, filterData, showSaveFilterWin, categoryData, appendFields, savedFilter, advRef, saveFormRef, projectId, dataRules, open, showSaveAdvFilter, saveAdvFilter, searchData, closeDialog, closeSaveDialog, AdvSearch }
}

})